// tslint:disable: curly
import { Component, Input, OnInit } from '@angular/core';
import { AcctHelpers } from 'src/app/acct-comps/helpers';
import { NotifyService } from 'src/app/core/layouts/notifications/notify/notify.service';
import { IAccount } from '../../../../../acct-comps/accounts.interfaces';
import { IDirectory } from '../../directory.interfaces';
import { DirectoryListingsRow } from '../directory-listings.interfaces';
import { DirectoryListingsService } from '../directory-listings.service';
import { ILocation } from './../../../../../loc-comps/locations.interfaces';

@Component({
  selector: 'app-directory-location-listings',
  templateUrl: './directory-location-listings.component.html',
  styleUrls: ['./directory-location-listings.component.scss'],
})
export class DirectoryLocationListingsComponent implements OnInit {
  loading = true;
  VENDOR_IMAGES = this.acctHelpers.VENDOR_IMAGES;
  listings: DirectoryListingsRow[];
  copyToClipboard: string;

  @Input() account: IAccount;
  @Input() location: ILocation;
  @Input() directory: IDirectory;

  constructor(
    private notifyService: NotifyService,
    private acctHelpers: AcctHelpers,
    private directoryListingsService: DirectoryListingsService
  ) {}

  ngOnInit(): void {
    this.getListings();
  }

  private getListings(): void {
    const global = typeof this.account?.global === 'string' ? JSON.parse(this.account?.global) : this.account?.global;
    this.directoryListingsService.getListingsByLocation(this.location._id).subscribe((v) => {
      v.forEach(l => {
        Object.keys(global).forEach(k => {
          if(l.vendor === k) {
            l['displayDir'] = global[k].publish;
          }
        })
      });
      this.listings = v.map((l) => {
        if (l.vendor === 'factual') {
          return {
            ...l,
            vendor: 'foursquare',
          };
        } else {
          return l;
        }
      });
      this.loading = false;
    });
  }

  handleCopyToClipboard(link) {
    this.copyToClipboard = link;
    this.notifyService.info('Link was successfully copied to clipboard');
  }
}
